import { CurrencyAmount } from '@groma-dev/scaffold';
import { Wallet } from './wallet';
import { BankAccount } from './bankAccount';

export enum FundType {
  FUND_ONE = 'Fund I',
  FUND_TWO = 'Fund II (GromaREIT)',
}

export type InvestmentAccountType = 'Individual' | 'Entity' | 'Trust';

export interface Account {
  id: number;
  type?: InvestmentAccountType;
  name: string;
  fund?: FundType;
  wallet: Wallet;
  bankAccount: BankAccount;
  created_at: string;
  updated_at: string;
  investment_fund: {
    display_name: string;
    description: string;
  };
  portfolio_value: CurrencyAmount;
  share_count: number;
  total_contribution: CurrencyAmount;
  permissions?: {
    investment_account: string[];
    bank_account: string[];
  };
}
